import PreviewCard, { SIZE, VARIANTS } from './PreviewCard';

export { VARIANTS, SIZE };
export default PreviewCard;
